module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right"
  }, [_c('ul', {
    staticClass: "nav clearfix"
  }, [(_vm.planTime !== null) ? _c('li', [_c('span', {
    staticClass: "el-dropdown-link dropdown-padding",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'alarmNotify',
          query: {
            notice_accounts: _vm.$store.getters.account.name
          }
        })
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon-14 fa fa-envelope-open"
  }), _vm._v(" "), _c('translate', [_vm._v("Alarm")]), _vm._v(" "), (_vm.$store.getters.logs.alarmNotifyUnreadCounts) ? _c('span', {
    staticClass: "link-num"
  }, [_vm._v(" " + _vm._s(_vm.$store.getters.logs.alarmNotifyUnreadCounts) + " ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.planTime !== null) ? _c('li', [_c('span', {
    staticClass: "el-dropdown-link dropdown-padding",
    on: {
      "click": _vm.showConnectList
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon-14 fa fa-link"
  }), _vm._v(" "), _c('translate', [_vm._v("Online Sessions")]), _vm._v(" "), (_vm.currentConnectCount) ? _c('span', {
    staticClass: "link-num"
  }, [_vm._v(" " + _vm._s(_vm.currentConnectCount) + " ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$language.current === 'zh_CN') ? _c('li', [_c('a', {
    staticClass: "dropdown-padding",
    attrs: {
      "href": "https://mrdoc.cloudcare.cn/doc/261/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-14 material-icons"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('translate', [_vm._v("Help")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.planTime !== null && _vm.$language.current === 'zh_CN') ? _c('li', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "dropdown-padding"
  }, [_c('i', {
    staticClass: "icon-14 material-icons"
  }, [_vm._v("group")]), _vm._v(" "), _c('a', [_c('translate', [_vm._v("Contact US")])], 1)]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('p', [_c('translate', [_vm._v("Customer Service")]), _vm._v(":\n\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "wang-item btn",
    attrs: {
      "target": "_blank",
      "href": "https://work.weixin.qq.com/kfid/kfc63de878415ef9ba5"
    }
  }, [_c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("Immediate Consultation")])], 1)], 1)]), _vm._v(" "), _c('el-dropdown-item', [_c('p', [_c('translate', [_vm._v("Contact Number")]), _vm._v(": "), _c('span', [_vm._v("021-50653160")])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.planTime !== null) ? _c('li', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.onSelectLanguage
    }
  }, [_c('a', {
    staticClass: "el-dropdown-link dropdown-padding"
  }, [_c('i', {
    staticClass: "fa fa-globe fa-lg"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$language.current === 'zh_CN' ? '简体中文' : 'English'))])]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "en_US"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "zh_CN"
    }
  }, [_vm._v(" 简体中文 ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('el-tooltip', {
    attrs: {
      "placement": "bottom",
      "effect": "light"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('span', [_vm._v("套餐到期时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.memberExpireTime.text))])]), _vm._v(" "), _c('a', {
    staticClass: "el-dropdown-link dropdown-padding",
    class: _vm.memberExpireTime.isExpire || _vm.memberExpireTime.matured ? 'isExpire' : ''
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.packageInfo.current_plan ? _vm.packageInfo.current_plan.name : ''))]), _vm._v(" "), (_vm.memberExpireTime.isExpire) ? _c('span', [_vm._v("（即将到期）")]) : _vm._e(), _vm._v(" "), (_vm.memberExpireTime.matured) ? _c('span', [_vm._v("（已到期）")]) : _vm._e()])])], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleClickMenu
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link dropdown-padding"
  }, [_c('a', {
    staticClass: "photo clearfix"
  }, [_c('img', {
    attrs: {
      "src": _vm._f("resetURL")(_vm.account.avatar),
      "border": "0"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.account.name))])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right caret-download"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    }
  }, [_c('translate', [_vm._v("Logout")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.account.unique_id) ? _c('li', [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "title": _vm.attrText.onlineSessions,
      "custom-class": "onlineUserDialiog",
      "visible": _vm.connectListDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.connectListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.batchDel.length
    },
    on: {
      "click": function($event) {
        _vm.cutOnline(_vm.batchDel)
      }
    }
  }, [_c('translate', [_vm._v("Disconnect")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.currentConnectList,
      "empty-text": _vm.attrText.noSession
    },
    on: {
      "selection-change": _vm.selectMultiple
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "prop": "account.name",
      "label": _vm.attrText.member
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(!scope.row.account ? '' : scope.row.account.name) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "label": " "
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.safe_mode) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unsafeMode,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-circle warn"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resource_name",
      "label": _vm.attrText.resource
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resource_ip_address",
      "label": _vm.attrText.resourceIp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "way",
      "label": _vm.attrText.resourceWay
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.resourceWayMap[scope.row.way]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project_name",
      "label": _vm.attrText.workgroup
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": _vm.attrText.updateTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row.createTime ? scope.row.createTime : '') + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agentVersion < '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !scope.row.linkHref || !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("Monitor")])], 1) : _vm._e(), _vm._v(" "), (scope.row.agentVersion >= '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          }
        }, [(scope.row.way === 'terminal' || scope.row.way === 'wetty') ? _c('span', {
          on: {
            "click": function($event) {
              _vm.createShadow(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("assistance")])], 1) : _vm._e(), _vm._v(" "), (scope.row.way === 'rdp' && scope.row.showRdp) ? _c('span', {
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("monitor")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.cutOnline([scope.row.id])
            }
          }
        }, [_c('translate', [_vm._v("Disconnect")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.currentConnectCount > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.currentConnectCount,
      "page-size": 10,
      "current-page": _vm.currentConnectPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentConnectPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-padding",
    attrs: {
      "id": "widget-notify-list"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c70255b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 615
// module chunks = 4 5 6